import { Button } from "@heycircle/ui/button";
import useLanguage from "@/services/i18n/use-language";
import useStoreLanguageActions from "@/services/i18n/use-store-language-actions";
import { languages } from "@/services/i18n/config";

export function LanguageSwitcher() {
  const activeLanguage = useLanguage();
  const { setLanguage } = useStoreLanguageActions();

  return (
    <div className="flex items-center gap-1">
      {languages.map((lang) => (
        <Button
          key={lang}
          variant={activeLanguage === lang ? "default" : "ghost"}
          size="sm"
          onClick={() => setLanguage(lang)}
          className="text-xs font-semibold px-2 h-7"
        >
          {lang.toUpperCase()}
        </Button>
      ))}
    </div>
  );
}
